import Airtable from 'airtable'

const credentials = {
  apiKey: process.env.VUE_APP_AIRTABLE_API_KEY,
  baseId: process.env.VUE_APP_AIRTABLE_BASE_ID,
  tableName: process.env.VUE_APP_AIRTABLE_TABLE_NAME,
  viewName: process.env.VUE_APP_AIRTABLE_VIEW_NAME,
  aboutContentTable: process.env.VUE_APP_AIRTABLE_ABOUT_CONTENT_TABLE,
  aboutContentView: process.env.VUE_APP_AIRTABLE_ABOUT_CONTENT_VIEW
}

const base = new Airtable({ apiKey: credentials['apiKey'] })
  .base(credentials['baseId'])

export const getDisasterData = async () => {
  const data = base(credentials['tableName']).select({
    view: credentials['viewName']
  }).all()

  return data
}

export const getAboutData = async () => {
  const data = base(credentials['aboutContentTable']).select({
    view: credentials['aboutContentView']
  }).all()

  return data
}

export const getRecordsFromData = (data) => {
  return data.map(d => d.fields)
}